/**
 * CSS critique (above-the-fold) inliné dans le <head> :
 * jetons de couleur, polices système de repli, fond/typo du body et
 * squelette de la navigation. Le reste de la feuille de styles est chargé
 * de manière asynchrone (media="print" puis bascule sur "all").
 */
export const CRITICAL_CSS = `
:root{
--paper:oklch(0.96 0.012 85);--ink:oklch(0.26 0.045 258);
--ocean:oklch(0.525 0.1146 238.7);--rule:oklch(0.86 0.015 80);
--background:var(--paper);--foreground:var(--ink);--border:var(--rule);
--font-sans:"Manrope Variable","Manrope",ui-sans-serif,system-ui,sans-serif;
--font-serif:"EB Garamond Variable","EB Garamond","Times New Roman",serif;
--font-display:"Cormorant Garamond Variable","Cormorant Garamond","Times New Roman",serif;
}
html.dark{--paper:oklch(0.21 0.03 258);--ink:oklch(0.95 0.008 85);
--ocean:oklch(0.74 0.115 238.7);--rule:oklch(0.34 0.022 258);}
*,*::before,*::after{box-sizing:border-box}
html{font-family:var(--font-sans);-webkit-font-smoothing:antialiased;line-height:1.5}
body{margin:0;background-color:var(--background);color:var(--foreground);
font-feature-settings:"ss01","kern";min-height:100vh}
h1,h2,h3{font-family:var(--font-serif);font-weight:600;letter-spacing:-0.015em;margin:0}
p{margin:0}
img,video{max-width:100%;height:auto;display:block}
a{color:inherit;text-decoration-line:underline;text-decoration-color:var(--ocean);text-decoration-thickness:1.5px;text-underline-offset:4px}
a[class*="rounded-"],a[class~="border"],.no-link-underline,.no-link-underline *,.portfolio-content a,.portfolio-content a *{text-decoration-line:none!important}
[hidden]{display:none!important}
`.trim();
